'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _reactPopper = require('react-popper'),
    _themes = require('../../themes'),
    _propTypes3 = require('../../propTypes');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  Target: (0, _styledComponents2.default)(_reactPopper.Target).withConfig({
    displayName: 'PopoverTrigger__Target'
  })(['display:inline-block;'])
},
    PopoverTrigger = function (_Component) {
  function PopoverTrigger() {
    return _classCallCheck(this, PopoverTrigger), _possibleConstructorReturn(this, (PopoverTrigger.__proto__ || Object.getPrototypeOf(PopoverTrigger)).apply(this, arguments));
  }

  return _inherits(PopoverTrigger, _Component), _createClass(PopoverTrigger, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          themeIgnored = _props.theme,
          otherProps = _objectWithoutProperties(_props, ['children', 'theme']);

      return _react2.default.createElement(Styled.Target, _extends({
        component: 'span'
      }, otherProps), (0, _react.cloneElement)(children, otherProps));
    }
  }]), PopoverTrigger;
}(_react.Component);

PopoverTrigger.propTypes = {
  children: _propTypes2.default.node.isRequired,
  theme: _propTypes3.themeShape
}, PopoverTrigger.defaultProps = {
  theme: (0, _themes.createTheme)()
}, PopoverTrigger.displayName = 'PopoverTrigger';
var PopoverTriggerWithTheme = (0, _themes.withTheme)(PopoverTrigger);
PopoverTriggerWithTheme.WrappedComponent = PopoverTrigger, exports.default = PopoverTriggerWithTheme;